import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Uploader } from "uploader";
import { UploadDropzone } from "react-uploader";
import { createWorker } from "tesseract.js";

const uploader = Uploader({ apiKey: "public_FW25b4W3tfMkaxRFspthDMiav1y3" }); // Your real API key.
const uploaderOptions = {
  multi: true,
  showFinishButton: true,
  showFiles: true,

  styles: {
    colors: {
      primary: "#377dff",
    },
  },
};

function App() {
  const worker = createWorker();
  const [recognizedText, setRecognizedText] = React.useState("");

  const handleUpdate = async (files) => {
    const fileUrl = files[0].fileUrl;
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    await worker.load();
    await worker.loadLanguage("eng");
    await worker.initialize("eng");
    const {
      data: { text },
    } = await worker.recognize(blob);
    setRecognizedText(text);
    console.log(text); // Log the recognized text to the console.
  };

  return (
    <div className='App'>
      <header>
        <div className='layout1'>
          <h1 className='text1'>
            Welcome to JobAI <span class='wave'>👋</span>
          </h1>
        </div>
      </header>
      <div className='resumelayout'>
        <UploadDropzone
          uploader={uploader}
          options={uploaderOptions}
          onUpdate={handleUpdate}
          width='700px'
          height='800px'
        />
        <div>{recognizedText}</div>
      </div>
    </div>
  );
}

export default App;
